<template>
  <div class="page-container">
    <div class="row ml-1">
      <h4 class="mb-4 mr-2">Lista użytkowników</h4>
      <div>
        <b-button size="sm" @click="addDoctor">
          <span data-feather="plus"></span>
          Dodaj użytkownika
        </b-button>
      </div>
    </div>
    <div class="row col-12">
      <b-form-group
        id="input-group-search"
        label="Wyszukaj:"
        label-for="input-search"
        description="Wyszukaj po: imieniu, nazwisku, NPWZ, tytule, nr. tel."
      >
        <b-form-input
          id="input-search"
          v-model="filter"
          type="search"
          placeholder="Wpisz wyszukiwaną fraze"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-empty
      stacked="md"
      :busy.sync="isBusy"
      responsive
    >
      <template v-slot:cell(account_type)="row">
        <span v-if="row.item.account_type === 'consultant'">Konsultant zewnętrzny</span>
        <span v-else-if="row.item.account_type === 'specialist'">Personel medyczny kliniki</span>
        <span v-else-if="row.item.account_type === 'doctor'"
          >Personel medyczny kliniki z funkcją konsultanta</span
        >
        <span v-else-if="row.item.account_type === 'clinic_staff'">Personel kliniki</span>
        <span v-else-if="row.item.account_type === 'clinic_staff_with_consultant_feature'"
          >Personel kliniki z funkcją konsultanta</span
        >
        <span v-else-if="row.item.account_type === 'clinic_office'">Gabinet - tablet</span>
      </template>
      <template v-slot:cell(api_keys)="{ item }">
        {{
          JSON.parse(item.api_keys || '[]')
            .map(key => allowedApiKeys[key])
            .join(', ')
        }}
      </template>
      <template v-slot:cell(patient_search_feature)="row">
        {{ !!row.item.patient_search_feature === true ? 'Tak' : 'Nie' }}
      </template>
      <template v-slot:cell(access_medical_records)="row">
        {{ !!row.item.access_medical_records === true ? 'Tak' : 'Nie' }}
      </template>
      <template v-slot:cell(access_additional_tests)="row">
        {{ !!row.item.access_additional_tests === true ? 'Tak' : 'Nie' }}
      </template>
      <template v-slot:cell(access_to_prepare_visits)="row">
        {{ !!row.item.access_to_prepare_visits === true ? 'Tak' : 'Nie' }}
      </template>

      <template v-slot:cell(actions)="row">
        <b-button-group>
          <b-button class="btn-warning mr-1" size="sm" @click="sendWelcomeSMS(row)"
            >Wyślij powitalny SMS</b-button
          >
          <b-button class="btn-primary mr-1" size="sm" @click="editDoctor(row)">Edycja</b-button>
          <!--          <b-button class="btn-primary mr-1" size="sm" @click="openStats(row)">Statystyki</b-button>-->
          <b-button class="btn-danger" size="sm" @click="deleteDoctor(row)">Usuń</b-button>
        </b-button-group>
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.currentPage"
      :total-rows="pagination.totalRows"
      :per-page="pagination.perPage"
      @change="fetchResults"
    ></b-pagination>
  </div>
</template>

<script>
import _ from 'lodash'
import mixin from '../../../mixin'

export default {
  name: 'Doctors',
  mixins: [mixin],
  async mounted() {
    const vm = this
    await vm.fetchAllowedApiKeys()
    vm.fetchResults(1)
  },
  data() {
    return {
      pagination: {
        totalRows: 0,
        currentPage: 1,
        perPage: 20
      },
      sortBy: '',
      filter: '',
      sortDesc: null,
      fields: [
        { key: 'title', label: 'Tytuł' },
        { key: 'name', label: 'Imię', sortable: true },
        { key: 'last_name', label: 'Nazwisko', sortable: true },
        { key: 'account_type', label: 'Typ', sortable: true },
        { key: 'api_keys', label: 'Lokalizacje', sortable: true },
        {
          key: 'patient_search_feature',
          label: 'Dostęp do wyszukiwarki pacjentów',
          sortable: true
        },
        {
          key: 'access_medical_records',
          label: 'Dostęp do dokumentacji medycznej',
          sortable: true
        },
        {
          key: 'access_additional_tests',
          label: 'Dostęp do badań dodatkowych',
          sortable: true
        },
        {
          key: 'access_to_prepare_visits',
          label: 'Uprawnienie do przygotowywania wizyt',
          sortable: true
        },
        { key: 'created_at', label: 'Data utworzenia', sortable: true },
        { key: 'actions', label: 'Akcje' }
      ],
      items: [],
      isBusy: true,
      allowedApiKeys: {}
    }
  },
  watch: {
    filter: _.debounce(function () {
      this.fetchResults(1)
    }, 300),
    sortDesc() {
      this.fetchResults(1)
    },
    sortBy() {
      this.fetchResults(1)
    }
  },
  methods: {
    async fetchAllowedApiKeys() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const apiKeys = response.data
        // eslint-disable-next-line no-restricted-syntax
        for (const key of apiKeys) {
          vm.allowedApiKeys[key.api_key] = key.name
        }
      })
    },
    sendWelcomeSMS(row) {
      const vm = this
      // eslint-disable-next-line camelcase
      const { user_id } = row.item
      vm.$http
        .post('e-zacma/consultant/send-welcome-sms', { id: user_id })
        .then(() => {
          vm.$success()
        })
        .catch(() => {
          vm.$error()
        })
    },
    fetchResults(page) {
      const vm = this
      vm.isBusy = true

      const query = vm.setQuery(page)
      vm.$http.post(`e-zacma/list-doctors?${query}`).then(response => {
        const { data } = response
        vm.items = data.data
        vm.pagination.totalRows = data.total
        vm.pagination.currentPage = data.current_page
        vm.pagination.perPage = data.per_page
        vm.isBusy = false
      })
    },
    setQuery(page) {
      const vm = this
      const query = []

      query.page = page
      query.perPage = 20
      if (vm.filter) {
        query.search = vm.filter
      }
      if (vm.sortBy) {
        query.sortBy = vm.sortBy
        query.orderBy = 'asc'
        if (vm.sortDesc) {
          query.orderBy = 'desc'
        }
      }

      return vm.buildQueryString(query)
    },
    openStats(row) {
      this.$router.push({ name: 'doctor-split-view', params: { id: row.item.id } })
      // this.$router.push({ name: 'e-zacma-doctor-modify', params: { id: row.item.id, target: 'statistics' } })
    },
    editDoctor(row) {
      this.$router.push({ name: 'e-zacma-doctor-modify', params: { id: row.item.id } })
    },
    deleteDoctor(row) {
      const vm = this
      vm.$bvModal
        .msgBoxConfirm(
          `Czy na pewno chcesz usunąć użytkownika "${row.item.name} ${row.item.last_name}". Wynik tej operacji jest permanentny.`,
          {
            okVariant: 'danger',
            okTitle: 'Tak',
            cancelTitle: 'Nie',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(decision => {
          if (decision) {
            vm.$store.commit('addPageLoaderEvent', 'delete-consultant')
            // eslint-disable-next-line camelcase
            const { id, user_id } = row.item
            vm.$http
              .post('e-zacma/doctor/delete', { id, user_id })
              .then(() => {
                vm.fetchResults(vm.pagination.currentPage)
                vm.$toast.success({
                  message: `Użytkownik "${row.item.name}" został skasowany.`
                })
              })
              .catch(e => vm.$error())
              .finally(() => {
                vm.$store.commit('removePageLoaderEvent', 'delete-consultant')
              })
          }
        })
    },
    addDoctor() {
      this.$router.push({ name: 'e-zacma-add-doctor' })
    }
  }
}
</script>

<style scoped></style>
